import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VueHttpClientService, VueLoadingService, VueSessionCookieService } from '@vue/vueframework';
import { Observable } from 'rxjs';
import { ResourceFile } from '../types/resource-file.model';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class SupportMaterialsService {
  public get siteId(): number {
    const realm = JSON.parse(this.vueSessionCookieService.getAttribute('realmDetail', 'VUE'));
    const siteId = JSON.parse(this.vueSessionCookieService.getAttribute('siteID', 'VUE'));
    const selectedSiteId = siteId || realm?.siteID;
    return Number(selectedSiteId);
  }

  public get connectBase(): string {
    return 'api/v1/siteResources/sites/' + this.siteId;
  }

  public get siteMaintenanceSupportServicesUrl(): string {
    return this.appConfig.getSiteMaintenanceSupportServicesUrl();
  }

  public constructor(
    private http: HttpClient,
    private vueLoadingService: VueLoadingService,
    private vueSessionCookieService: VueSessionCookieService,
    private appConfig: AppConfigService
  ) { }

  public vueHttpClient(): VueHttpClientService {
    return new VueHttpClientService(
      this.http,
      this.vueLoadingService);
  }

  public getDownloadUrl(fileId: number): Observable<{ url: string, fileName: string }> {
    const url = [
      this.siteMaintenanceSupportServicesUrl,
      this.connectBase,
      `files/${ fileId }/downloadURI`
    ].join('/');
    return this.vueHttpClient().get(url);
  }

  public getFileDetails(fileId: string | number): Observable<ResourceFile> {
    const url = [
      this.siteMaintenanceSupportServicesUrl,
      this.connectBase,
      'files',
      fileId
    ].join('/');
    return this.vueHttpClient().get(url);
  }
}
